exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "main[data-v-0706711b]{font-family:DM sans;height:auto;display:flex;justify-content:space-evenly;align-items:center;width:100%;position:relative;padding:50px 0;background:#fff}.items[data-v-0706711b]{margin-bottom:50px}h1[data-v-0706711b]{font-size:50px}p[data-v-0706711b]{font-size:20px}.get img[data-v-0706711b]{margin-top:20px;transition:all .5s}.get img[data-v-0706711b]:hover{transform:rotate(-4deg)}@media screen and (max-width:1062px){main[data-v-0706711b]{flex-direction:column;text-align:center}.main-img[data-v-0706711b]{width:300px}h1[data-v-0706711b]{font-size:30px}p[data-v-0706711b]{font-size:17px}.content[data-v-0706711b]{overflow:hidden;padding:10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0706711b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/homePage/Download.vue
// module id = 96
// module chunks = 0